import { isEmailAddressValid } from '../../../../../services/email-sanitation/isEmailAddressValid';
import { errorMessages } from '../../messages';

export const getDefaultProfileErrorState = () => ({
  fullName: [],
  email: [],
});

export const validateProfile = ({ fullName, email }) => {
  const errors = getDefaultProfileErrorState();

  if (!fullName) {
    errors.fullName.push(errorMessages.cannotBeEmpty);
  }

  if (!email) {
    errors.email.push(errorMessages.cannotBeEmpty);
  }

  if (!isEmailAddressValid(email)) {
    errors.email.push(errorMessages.invalidEmailSyntax);
  }

  return errors;
};
